export enum StorageApiKeys {
  UserHistory = 'userHistory',
}
